import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { SxProps } from "@mui/material";
import { signIn, signOut } from "../supabase";
import NotificationService from "../components/notification/NotificationService";
import { useAppSelector } from "../hooks";
import Logo from "../components/Logo";

export const textfieldStyle: SxProps = {
  margin: "5px 0px",
  width: "80%",
  maxWidth: "300px",
  "& label": {
    color: "#715939",
  },

  "& .MuiFilledInput-root": {
    backgroundColor: "transparent",
  },
  "& .MuiFilledInput-root.Mui-focused": {
    backgroundColor: "transparent",
  },
  input: {
    textAlign: "center",
    color: "#715939",
    fontSize: 14,
    fontFamily: "Lato-regular",
    letterSpacing: "1px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#715939",
    },
    "&:hover fieldset": {
      borderColor: "#715939",
    },
  },
};

const Login = () => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const isAdmin = useAppSelector((state) => state.app.isAdmin);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (email && password) {
      signIn(email, password)
        .then(() => {
          NotificationService.showToast({
            severity: "success",
            text: "Velkommen tilbage!",
          });
        })
        .catch((e) => {
          console.error(e);
          NotificationService.showToast({ severity: "error", text: e });
        });
    } else {
      NotificationService.showToast({
        severity: "error",
        text: "Email or password is missing",
      });
    }
  };

  const signOutHandler = () => {
    signOut();
  };

  return (
    <>
      <div className="login">
        <Logo size="30" color="#715939" />
        <h1>Administrator</h1>

        {isAdmin ? (
          <Button onClick={signOutHandler} type="submit" variant="outlined">
            Sign out
          </Button>
        ) : (
          <>
            <TextField
              required
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              sx={textfieldStyle}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              required
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="new-password"
              sx={textfieldStyle}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              onClick={(e) => handleSubmit(e)}
              type="submit"
              variant="outlined"
            >
              Sign in
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default Login;
